import { mapGetters } from 'vuex'
import localStorage from '@/mixins/localStorage';

export default {
    mixins: [ localStorage ],
    created() {

    },
    mounted() {
        this.UserImg = this.getUserImg;
    },
    data() {
        return {
            UserImg : {}
        }
    },
    watch: {
        getUserInfo: function(newValue, oldValue) {
            this.UserInfo = newValue;
        },
        getSiteLogo: function(newValue, oldValue) {
            this.UserImg = newValue;
        }
    },
    computed: {
        ...mapGetters({
            getUserInfo: 'userInfo/getUserInfo',
            getUserImg: 'common/getUserImg'
        }),
    },
    method: {
     /*   checkUser(){
            let params = {m_type : 'admin'}
            this.$api.$auth.getMember(params).then( res => res.Data.Result).then(res => {
                if(res.Info.status === true){
                    this.$store.dispatch('common/initUserInfo', {info : res.List[0]} );
                    if(path !== "") {
                        this.$router.push({path: path});
                    }
                }
            }, () => {
                console.log('error');
                this.localLogout();
            })
        }*/

    }
}
